$(window).on("load", function() {
	const $header = $("header.header");
	const $mobileToggles = $("button.header__mobile-toggle");
	const $mainList = $(".header__main-nav");
	const $backBtns = $("button.header__secondary-back");
	const $searchDropdown = $(".header__search-dropdown");
	const $searchWrapper = $(".header__search");
	const $mobileOverlay = $(".header__mobile-overlay");
	const $searchFlyout = $(".header__search-flyout");
	const $searchTrigger = $(".header__search-trigger");
	const $searchTriggerText = $(".header__search-trigger-text");
	const $searchInput = $("input.header__search-input");
	const $searchClear = $(".header__search-clear");
	const pageIsRMF = !!$header[0]?.closest(".page--RM");
	const pageIsORG = !!$header[0]?.closest(".page--ORG, .page--BUY, .page--BOB, .page--TXC, .page--TSP, .page--ENC");
	let $vh = $(window).height() * 0.01;
	$(document.documentElement).css('--vh', `${$vh}px`);
	let mainNavHeight;
	if (window.innerWidth < 1199) mainNavHeight = $(".header__main-nav").height();

	const openNavMenu = () => {
		if (pageIsORG) $mainList.css("top", `${$("header.header").outerHeight()}px`);
		$header.addClass("menu-open");
		if (!pageIsORG) $(window).scrollTop(0);
		$("html").css("overflow", "hidden");
		$("body").css("overflow", "hidden");
	}

	const closeNavMenu = () => {
		$header.removeClass("menu-open");
		$('.mobile-is-open').removeClass("mobile-is-open");
		$("html").css("overflow", "");
		$("body").css("overflow", "");
		if (!pageIsRMF) $(".header__main-nav").css("min-height", "");
	}

	const toggleMobileMenu = () => {
		if (!$header.hasClass("menu-open")) openNavMenu();
		else closeNavMenu();
	}

	// Close dropdown if user tabs out of it to next nav item
	const navBlur = (e) => {
		const item = e.target.closest(".header__main-item, .header__util-item");
		if (item && !item.matches(":focus-within")) {
			item.classList.remove("is-open");
		}
	}

	const toggleNavDropdown = (e) => {
		// If user clicks inside of dropdown/sub nav, do nothing
		let dropdownSelectorString = ".header__secondary, .header__member-dropdown, .header__district-dropdown, .header__utilities-dropdown, .header__util-mobile-dropdown";
		if (e.target.matches(dropdownSelectorString) || e.target.closest(dropdownSelectorString)) return;
		const item = e.target.closest(".header__main-item, .header__util-item");
		const clickedItemIsOpen = item?.matches(".is-open") || false;
		// For mobile
		if (window.innerWidth < 1199) {
			if (item?.matches(".header__main-item")) {
				const subList = item.querySelector(".header__secondary");
				if (!pageIsRMF && !pageIsORG) $mainList.css("min-height", $(subList).outerHeight());
				if (pageIsRMF) {
					let hasAlert = !!document.querySelector(".alert.alert--showing");
					$(subList).css("height", `calc(100 * var(--vh) - ${$("header.header").outerHeight()}px - ${hasAlert ? $(".alert.alert--showing").outerHeight() : 0}px)`);
					$(subList).css("overflow-y", "auto");
				}
				if (pageIsORG) {
					if (!!document.querySelector(".alert--showing")) {
						$mainList.css("min-height", `calc(100 * var(--vh) - (${$(".alert--showing").outerHeight() + $("header.header").height()}px))`);
						$mainList.css("max-height", `calc(100 * var(--vh) - (${$(".alert--showing").outerHeight() + $("header.header").height()}px))`);
					}
					else {
						$mainList.css("min-height", `calc(100 * var(--vh) - ${$("header.header").outerHeight()}px)`);
						$mainList.css("max-height", `calc(100 * var(--vh) - ${$("header.header").outerHeight()}px)`);
					}
					$mainList.css("top", `${$("header.header").outerHeight()}px`);
				}
				$(item).addClass("mobile-is-open");
			} else if (item?.matches(".header__util-item") && !item?.matches(".header__util-item--login")) {
				$(".header__util-item.is-open").removeClass("is-open");
				$mobileOverlay.removeClass("is-active");
				closeNavMenu();
				if (!clickedItemIsOpen) {
					$(item).addClass("is-open");
					$mobileOverlay.addClass("is-active");
				}
			} else if (!e.target.closest(".header__main-item, .header__util-item")) {
				$(".header__main-item.is-open, .header__util-item.is-open").removeClass("is-open");
			}
			if (window.innerWidth < 560 && pageIsORG) {
				if (item?.matches(".header__util-item--mobile")) {
					if (item.querySelector(".header__member-dropdown")) {
						item.querySelector(".header__member-dropdown").style.transform = "unset";
						item.querySelector(".header__member-dropdown").style.left = `-${item.getBoundingClientRect().left}px`;
					}
				}
			} else if (pageIsORG) {
				if (item?.matches(".header__util-item--mobile")) {
					if (item.querySelector(".header__member-dropdown")) {
						item.querySelector(".header__member-dropdown").style.transform = "";
						item.querySelector(".header__member-dropdown").style.left = "";
					}
				}
			}
		// For desktop
		} else {
			// If on desktop and user clicks outside of dropdown, close any open dropdown
			if (!e.target.closest(".header__main-item, .header__util-item")) {
				$(".header__main-item.is-open, .header__util-item.is-open").removeClass("is-open");
			} else {
				$(".header__main-item.is-open, .header__util-item.is-open").removeClass("is-open");
				if (!clickedItemIsOpen && !!item) {
					if (item.matches(".header__main-item:first-child, .header__main-item:nth-child(2), .header__main-item:nth-child(3)")) {
						const subList = item.querySelector(".header__secondary");
						subList.style.left = "";
						const subWidth = subList.offsetWidth;
						const subLeft = subList.getBoundingClientRect().left;
						if (subLeft + subWidth > window.innerWidth + 5 || subLeft < 0) {
							subList.style.left = `${window.innerWidth - (subLeft + subWidth)}px`;
						}
					}
					$(item).addClass("is-open");
				}
			}
		}
	}

	// ######################################################
	// Reset things if screen is resized between Mobile Style
	// and Desktop Style breakpoints  #######################
	const handleWindowResize = () => {
		$vh = $(window).height() * 0.01;
		$(document.documentElement).css('--vh', `${$vh}px`);
		if (window.innerWidth < 1199) {
			$(".header__main-item.is-open").removeClass("is-open");
		} else {
			$('.mobile-is-open').removeClass("mobile-is-open");
			if (!pageIsRMF) {
				$(".header__main-nav").css("min-height", "");
				$(".header__menu-container").css("min-height", "");
				if (pageIsORG) $mainList.css("top", "");
			} else {
				$(".header__secondary").css("height", "");
				$(".header__secondary").css("overflow-y", "");
			}
			$header.removeClass("menu-open");
			$("body").css("overflow", "");
			$("html").css("overflow", "");
		}
	}

	$(document).click(toggleNavDropdown)
	$mobileToggles.click(toggleMobileMenu);
	$mobileToggles.blur((e) => navBlur(e));
	$(".header__secondary-link, .header__member-link, .header__district-link").blur((e) => navBlur(e));
	$(".header__main-toggle, .header__member-trigger, .header__district-trigger").blur((e) => navBlur(e));
	$(window).resize(handleWindowResize);

	$backBtns.click(() => {
		$('.mobile-is-open').removeClass("mobile-is-open");
		if (!pageIsRMF) $(".header__main-nav").css("min-height", "");
	});
		
	// ###########################################################
	// SEARCH SCRIPTS - GENERAL  ###############################
	// only run if trigger and dropdown container are both on page
	const clearSearchInput = e => {
		e.preventDefault();
		$searchInput[0].value = "";
		$searchWrapper.removeClass("has-text");
	}
	if(!!$searchClear.length && !!$searchInput.length) $searchClear.click(clearSearchInput);
		
	// ############################################
	// SEARCH QUERY FUNCTIONALITY  ################
	let $searchForm = $("form.header__search-form");
	if (!!$searchForm.length) {
		$searchForm.submit(e => {
			e.preventDefault();
			let value = $searchInput[0].value;
			let path = $searchForm.attr("data-search-path");
			// IF SEARCH PATH STRING ENDS IN TRAILING "/" THEN REMOVE IT
			if (path[path.length - 1] == "/") path = path.slice(0, path.length - 1);
			if (!!value && !!path) {
				path += `?query=${encodeURIComponent(value)}`;
				window.location = path;
			}
		});
		$searchInput.on("keyup", e => {
			let val = e.target.value;
			if (!!val) $searchWrapper.addClass("has-text");
			else $searchWrapper.removeClass("has-text");
		});
	}

	if (!!$searchDropdown.length && !!$searchTrigger.length) {
		// ###########################################################
		// SEARCH MODAL FUNCTIONALITY  ###############################
		// only run if trigger and dropdown container are both on page
		const toggleSearchModal = () => {
			$searchDropdown.toggleClass("is-open");
			$searchTrigger.toggleClass("close");
			$searchDropdown.slideToggle();
			if ($searchDropdown[0].matches(".is-open")) {
				$searchInput.focus();
				$(".header__util-item.is-open").removeClass("is-open");
				$searchTrigger[0].setAttribute("aria-label", "Close Search Form Dropdown");
			} else {
				$searchTrigger[0].setAttribute("aria-label", "Open Search Form Dropdown");
			}
		}
		
		$searchTrigger.click(toggleSearchModal);
		$searchClear.click(clearSearchInput);
	}


	if (!!$searchFlyout.length && !!$searchTrigger.length && !!$searchWrapper.length) {
		const openSearchFlyout = () => {
			$searchWrapper.addClass("is-open");
			$searchFlyout.css("max-width", `${$searchFlyout.offset().left + $searchFlyout.width()}px`);
			$searchTrigger.attr("aria-label", "Close site search flyout");
			$searchTriggerText.text("Close");
			$mobileOverlay.addClass("is-active");
			setTimeout(() => {$searchInput.focus()}, 300);
		}
		const closeSearchFlyout = refocus => {
			$searchWrapper.removeClass("is-open");
			if (refocus) $searchTrigger.focus();
			$searchTrigger.attr("aria-label", "Open site search flyout");
			$searchTriggerText.text("Search");
			$mobileOverlay.removeClass("is-active");
		}

		$searchTrigger.click(() => {
			if ($searchWrapper.hasClass("is-open")) closeSearchFlyout(true);
			else openSearchFlyout();
		});
		$("body").click(e => {
			if (!e.target.closest(".header__search") && !e.target.matches(".header__search")) closeSearchFlyout();
		});
	}

	// ############################################
	// GENERATE USER NAME LABEL FOR MOBILE DROPDOWN
	const $memberName = $("span.header__member-name").text();
	const $memberDropdown = $("ul.header__member-dropdown");
	let $nameLabel = $("<li class=\"header__member-item header__member-item--mobile\"></li>").text($memberName);
	$memberDropdown.prepend($nameLabel);

	// #######################################
	// DISTRICT DROPDOWN #####################
	const districtDropdown = document.querySelector("ul.header__district-dropdown, ul.header__utilities-dropdown");
	const districtOptions = !!districtDropdown ? [...districtDropdown.querySelectorAll("a[data-district-id]")] : [];

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return false;
	}

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	if (!!districtOptions.length){
		districtOptions.forEach(link => {
			let districtId = link.getAttribute("data-district-id");
			link.addEventListener("click", e => {
				e.preventDefault();
				setCookie("currentDistrictId", districtId, 36525);
				window.location.reload();
			});
		});

		let activeDistrictId = getCookie("currentDistrictId");
		let activeDistrictLink = districtOptions.find(opt => opt.getAttribute("data-district-id") == activeDistrictId);
		activeDistrictLink?.closest("li.header__district-item, li.header__utilities-item").classList.add("header__district-item--active");
	}

	// scroll events for semi-sticky TASB.org header
	if (pageIsORG) {
		document.body.classList.add("semi-sticky-header");
		let currentScroll = window.scrollY;
		const authDivPresent = !!$("header.header .header__auth").length;
		if (authDivPresent) $header.addClass("header--auth");
		const throttle = (fn, delay) => {
			let time = Date.now();
			return () => { 
				if((time + delay - Date.now()) <= 0) {
					fn(); 
					time = Date.now(); 
				} 
			} 
		}

		const checkScrollPosition = () => {
			let newScroll = window.scrollY;
			let activeAlert = document.querySelector(".alert.alert--showing");
			let alertHeight = activeAlert?.getBoundingClientRect().height || 0;
			if (newScroll < $header.outerHeight() || newScroll < currentScroll) {
				if (!!activeAlert) {
					$header.css("top", `${alertHeight}px`);
					if (!!activeAlert) activeAlert.style.top = ``;
				} else {
					$header.css("top", "");
				}
			} else {
				$header.css("top", `-${$header.outerHeight()}px`);
				if (!!activeAlert) activeAlert.style.top = `-${alertHeight}px`;
			}
			currentScroll = newScroll;
		}

		window.addEventListener('scroll', throttle(checkScrollPosition, 100)); 
	}

	

});
